export const officialReportingCalendar = {
  "f3b1d569-688c-4756-fc75-ecdd332b3147": {
    last_closed_official_date: "2026-03-28",
  },
  "cf344fa3-2497-b57f-489a-dd77068c77ff": {
    last_closed_official_date: "2026-03-28",
  },
};
